module.exports = __webpack_public_path__ + "img/pocket_entry_length.b5320c39.png";